import { Color } from 'core';
import styled from 'styled-components';

// A button styled to look like a text link
// Used for inline actions like "Clear all", "Deselect", etc.
export const TextLinkButton = styled.button`
  background: none;
  border: none;
  color: ${Color.primaryBlue};
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
  padding: 0;

  &:hover {
    color: ${Color.activeBlue};
  }

  &:disabled {
    color: ${Color.textGray};
    cursor: not-allowed;
  }
`;
